module.exports = __webpack_public_path__ + "img/cd.8316eaf8.svg";